import request from '@/utils/request'
import qs from 'qs'

export function getUserStatistics(data) {
    data = qs.stringify(data)
    return request({
        url: '/home/getUserStatistics',
        method: 'post',
        data
    })
}

export function getDeviceCount(data) {
    data = qs.stringify(data)
    return request({
        url: '/home/getDeviceCount',
        method: 'post',
        data
    })
}

export function getErrorInfo(data) {
    data = qs.stringify(data)
    return request({
        url: '/home/getErrorInfo',
        method: 'post',
        data
    })
}

export function getDynamic(data) {
    data = qs.stringify(data)
    return request({
        url: '/home/getDynamic',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/home.js